import { FC, ReactElement } from 'react';
import { CatHeading } from '@blocks-react/components/Heading';
import { CatButton } from '@blocks-react/components/Button';
import { CatIconArrowBack } from '@blocks-react/components/Icons/ArrowBack';
import { Drawer } from '../../common';

interface AccountStatusDrawerProps {
  children: ReactElement | ReactElement[];
  drawerProps: object;
  closeDrawer: () => void;
  accountStatusTitle: string;
  backButtonAriaLable: string;
}

export const AccountStatusDrawer: FC<AccountStatusDrawerProps> = ({
  drawerProps,
  accountStatusTitle,
  closeDrawer,
  children,
  backButtonAriaLable,
}) => {
  return (
    <Drawer {...drawerProps} onBlDrawerClose={closeDrawer} data-testid="account-status-drawer">
      <div slot="header" className="d-flex align-items-center">
        <CatButton
          hideText
          onClick={() => closeDrawer()}
          size="sm"
          variant="ghost"
        >
          <CatIconArrowBack slot="before" aria-label={backButtonAriaLable} />
        </CatButton>
        <CatHeading
          variant="title-sm"
          id="notification-filters-header"
          className="ms-3"
          aria-label={accountStatusTitle}
        >
          {accountStatusTitle}
        </CatHeading>
      </div>
      {children}
    </Drawer>
  );
};
